import { getSessionStorage } from './.'
import { getExtensionDebounceKeys, setExtensionDebounceKeys } from '../storage'

const SESSION_DEBOUNCE_KEYS = 'hb-session-debounce-keys'

// debounceFunc - return true once per web session
export const oncePerSession = (key, justChecking) => {
  const sessionStorage = getSessionStorage()
  if (!sessionStorage) {
    throw new Error('Browser does not support session storage. Key not saved. Consider using a different hook.')
  }

  const pastKeys = JSON.parse(sessionStorage.getItem(SESSION_DEBOUNCE_KEYS)) ?? []
  if (!pastKeys.includes(key)) {
    if (!justChecking) {
      pastKeys.push(key)
      sessionStorage.setItem(SESSION_DEBOUNCE_KEYS, JSON.stringify(pastKeys))
    }
    return true
  }

  return false
}

// debounceFunc - async - return true once per 24 hour period
export const oncePer24Hours = async (key, justChecking) => {
  const pastKeyTimeMap = await getExtensionDebounceKeys()
  const pastTime = pastKeyTimeMap[key]
  const checkTime = pastTime ? new Date(pastTime + 24 * 60 * 60 * 1000).getTime() : null
  const nowTime = new Date().getTime()

  if (!checkTime || nowTime > checkTime) {
    if (!justChecking) {
      await setExtensionDebounceKeys({
        ...pastKeyTimeMap,
        [key]: nowTime
      })
    }
    return true
  }

  return false
}
